import { LicenseInfo } from "@mui/x-license";

const muiXLicenseKey = process.env.WEBPACK_PUBLIC_MUI_X_LICENSE_KEY;

if (muiXLicenseKey) {
	LicenseInfo.setLicenseKey(muiXLicenseKey);
}
